import * as React from "react";
import { forwardRef } from "react";
const GoogleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  "data-category": "brands",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M23.766 12.2782c0-.8157-.0661-1.6359-.2072-2.43836H12.24v4.62096h6.4817c-.2689 1.4904-1.1332 2.8088-2.3987 3.6465v2.9984h3.867c2.2708-2.09 3.576-5.1766 3.576-8.8275"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M12.24 24.0013c3.2364 0 5.9658-1.0626 7.9544-2.8969l-3.867-2.9984c-1.0758.732-2.4648 1.1465-4.083 1.1465-3.13064 0-5.78506-2.1121-6.73747-4.9517H1.51648v3.0909c2.03711 4.0522 6.1863 6.6096 10.72352 6.6096"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M5.50253 14.2987c-.50266-1.4903-.50266-3.1041 0-4.59448V6.61328H1.51649c-1.702 3.39082-1.702 7.38562 0 10.77642z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M12.24 4.74966c1.7108-.02646 3.3643.61731 4.6033 1.79901l3.4261-3.42605C18.1 1.0855 15.2207-.034466 12.24.00080867 7.70277.00080867 3.55359 2.55822 1.51648 6.61481l3.98604 3.09094c.948-2.84402 3.60683-4.95609 6.73748-4.95609"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
const ForwardRef = forwardRef(GoogleIcon);
ForwardRef.category = "brands";
export { ForwardRef as GoogleIcon };